export default function Marquee({ items }) {
  return (
    <div className="overflow-hidden border-y border-line py-6 select-none" aria-hidden="true">
      <div className="marquee-track">
        {[0, 1].map((copy) => (
          <div key={copy} className="flex shrink-0 items-center">
            {items.map((t, j) => (
              <span
                key={j}
                className="mx-10 flex items-center gap-10 font-display text-2xl font-extrabold uppercase tracking-tight text-zinc-700 md:text-4xl"
              >
                {t}
                <span className="inline-block h-1.5 w-1.5 bg-crimson" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
